import React, { useEffect, useState } from 'react';
import LandingPage from '../LandingPage/LandingPage';
import MiDoctaRedirect from '../MiDoctaRedirect/MiDoctaRedirect';
import Loading from '../UI/Loading/Loading';
import { getConfiguracionMiDocta } from '../../services/configuracionMiDoctaServices';

const HomeRoute = () => {
  const [ForzarRerdirectMiDocta, setForzarRerdirectMiDocta] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getConfiguracionMiDocta()
      .then(data => {
        if (!data.ok) {
          throw new Error(data.error || 'Error obteniendo la configuración de MiDocta');
        }
        setForzarRerdirectMiDocta(Boolean(data?.return?.redireccionVeDiMiDocta));
      })
      .catch(error => {
        console.error('Error obteniendo la configuración de MiDocta:', error);
      })
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return <Loading show />;
  }

  return ForzarRerdirectMiDocta ? <MiDoctaRedirect /> : <LandingPage />;
};

export default HomeRoute;
